import { Modal, Button, Input, Select, Form, notification } from "antd";

const { Option } = Select;

type AddDiscrepancyModalProps = {
  open: boolean;
  onClose: () => void;
};

export default function AddDiscrepancyModal({
  open,
  onClose,
}: AddDiscrepancyModalProps) {
  const [form] = Form.useForm();
  const [api, contextHolder] = notification.useNotification();

  const handleClose = () => {
    form.resetFields();
    onClose();
  };

  const handleCreate = () => {
    form
      .validateFields()
      .then((values) => {
        api.open({
          message: (
            <span className="text-[#003832] font-semibold">
              Discrepancy created
            </span>
          ),
          description: `"${values.description}" has been added to the discrepancy queue.`,
          placement: "bottom",
          duration: 3,
        });
        handleClose();
      })
      .catch(() => {
        // Validation errors are rendered inline by the Form items.
      });
  };

  return (
    <>
      {contextHolder}
      <Modal
        title="Add discrepancy"
        open={open}
        onCancel={handleClose}
        width={560}
        footer={
          <div className="flex justify-end gap-2">
            <Button onClick={handleClose}>Cancel</Button>
            <Button type="primary" onClick={handleCreate}>
              Create discrepancy
            </Button>
          </div>
        }
        destroyOnClose
      >
        <Form form={form} layout="vertical" className="mt-2">
          <Form.Item
            label="Description"
            name="description"
            rules={[{ required: true, message: "Description is required" }]}
          >
            <Input placeholder="Describe the discrepancy..." />
          </Form.Item>
          <div className="grid grid-cols-2 gap-3">
            <Form.Item label="Subject" name="subject">
              <Input placeholder="Subject ID" />
            </Form.Item>
            <Form.Item label="Site" name="site">
              <Input placeholder="Site ID" />
            </Form.Item>
          </div>
          <div className="grid grid-cols-2 gap-3">
            <Form.Item label="Domain" name="domain">
              <Select placeholder="Select domain">
                <Option value="ae">AE</Option>
                <Option value="lb">LB</Option>
                <Option value="pro">PRO</Option>
                <Option value="dm">DM</Option>
              </Select>
            </Form.Item>
            <Form.Item label="Visit" name="visit">
              <Input placeholder="e.g. Week 8" />
            </Form.Item>
          </div>
          <div className="grid grid-cols-2 gap-3">
            <Form.Item label="Impact" name="impact">
              <Select placeholder="Select impact">
                <Option value="lock_risk">Lock risk</Option>
                <Option value="endpoint">Endpoint</Option>
                <Option value="protocol">Protocol</Option>
              </Select>
            </Form.Item>
            <Form.Item label="Severity" name="severity">
              <Select placeholder="Select severity">
                <Option value="critical">Critical</Option>
                <Option value="major">Major</Option>
                <Option value="minor">Minor</Option>
              </Select>
            </Form.Item>
          </div>
          <Form.Item label="Assign to" name="assignee">
            <Input placeholder="Search team members..." />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
}
